import { z } from "zod";
import {
  ACCOUNT_ID,
  ACH_ACCOUNT,
  ACH_ACCOUNT_NAME,
  ACH_BANK_NAME,
  ACH_ROUTING,
  AUTO_BILLING_ENROLL,
  AUTO_BILLING_LA,
  AUTO_BILLING_LA_END_DATE,
  AUTO_BILLING_LA_START_DATE,
  AUTO_BILLING_START_DATE,
  E_ACCOUNT_EMAIL,
  E_ACCOUNT_NAME,
  E_ACCOUNT_NO,
  E_ACCOUNT_PHONE,
  E_COM_SIGNUP,
  E_COM_START_DATE,
  PAYMENT_TYPE,
  ZELLE_URL,
} from "./consts";

export const schema = z.object({
  [ACCOUNT_ID]: z.string().optional(),
  [PAYMENT_TYPE]: z.string().min(1, "Please select payment type"),
  [ZELLE_URL]: z.string().optional(),
  [ACH_ROUTING]: z.string().optional(),
  [ACH_ACCOUNT]: z.string().optional(),
  [ACH_ACCOUNT_NAME]: z.string().optional(),
  [ACH_BANK_NAME]: z.string().optional(),
  [E_ACCOUNT_NO]: z.string().optional(),
  [E_ACCOUNT_NAME]: z.string().optional(),
  [E_ACCOUNT_EMAIL]: z.string().optional(),
  [E_ACCOUNT_PHONE]: z.string().optional(),
  [E_COM_SIGNUP]: z.boolean().optional(),
  [E_COM_START_DATE]: z
    .union([z.string(), z.date(), z.null(), z.undefined()])
    .refine((val) => {
      // 1. If it's null, undefined, or an empty string, skip validation (it's valid)
      if (!val || val === "") return true;
      
      // 2. Otherwise, check if it's a valid date
      return !isNaN(Date.parse(val.toString()));
    }, {
      message: "Invalid date format.",
    })
    .optional()
    .nullable(),
  [AUTO_BILLING_ENROLL]: z.boolean().optional(),
  [AUTO_BILLING_START_DATE]: z
    .union([z.string(), z.date(), z.null(), z.undefined()])
    .refine((val) => {
      // 1. If it's null, undefined, or an empty string, skip validation (it's valid)
      if (!val || val === "") return true;
      
      // 2. Otherwise, check if it's a valid date
      return !isNaN(Date.parse(val.toString()));
    }, {
      message: "Invalid date format.",
    })
    .optional()
    .nullable(),
  [AUTO_BILLING_LA]: z.boolean().optional(),
  [AUTO_BILLING_LA_START_DATE]: z
    .union([z.string(), z.date(), z.null(), z.undefined()])
    .refine((val) => {
      // 1. If it's null, undefined, or an empty string, skip validation (it's valid)
      if (!val || val === "") return true;
      
      // 2. Otherwise, check if it's a valid date
      return !isNaN(Date.parse(val.toString()));
    }, {
      message: "Invalid date format.",
    })
    .optional()
    .nullable(),
  [AUTO_BILLING_LA_END_DATE]: z
    .union([z.string(), z.date(), z.null(), z.undefined()])
    .refine((val) => {
      // 1. If it's null, undefined, or an empty string, skip validation (it's valid)
      if (!val || val === "") return true;
      
      // 2. Otherwise, check if it's a valid date
      return !isNaN(Date.parse(val.toString()));
    }, {
      message: "Invalid date format.",
    })
    .optional()
    .nullable(),
});

export type formValues = z.infer<typeof schema>;
